export default __webpack_public_path__ + "static/media/1995.5f26083d.png";